import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'indianNumberFormat',
    standalone: true
})
export class IndianNumberFormatPipe implements PipeTransform {
    transform(value: number | string): string {
        if (value == null || value === '') {
            return '';
        }
        let numStr = value.toString();
        if (isNaN(Number(numStr))) {
            return ''; 
        }
        let [integer, decimal] = numStr.split('.');
        if (integer.length <= 3) {
            return integer + (decimal ? '.' + decimal : '');
        }
        const lastThreeDigits = integer.slice(-3);
        const otherDigits = integer.slice(0, integer.length - 3);
        // Apply commas for lakhs and crores (group by 2 digits from the right)
        const formattedInteger = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThreeDigits;

        return formattedInteger + (decimal ? '.' + decimal : '');
    }
}